export default "__VITE_ASSET__d432c082__"